import React from "react";
import { Routes, Route,NavLink } from 'react-router-dom';
import { Examens } from "./Examen.links";
import 'bulma/css/bulma.min.css';
import Icon from "./Element/Icon";
import image from  '../assets/logo.png';

export const Accueil = () => {
   const imageUrl = 'joie.jpg';
  
  
    return(
      <>
       <header className="App">
    
    
       <nav className="navbar-nav navbar navbar-expand-lg navbar-light bg-light ">   
     
        
          
          <NavLink className="navbar-brand" href="/">
            <img
              className="logo-ifc"
              src={image}
              alt="logo ifc"
             
              width='60px'
            />
          </NavLink >
          
        
          <ul className="nav navbar-nav">
            <li className="">
              <NavLink to="/accueil">Accueil</NavLink>
            </li>
            <li className="">
              <NavLink to="/Examen">Faqs</NavLink>
            </li>
            <li className="">
              <NavLink to="/Contact">Contact</NavLink>
            </li>
        
            <li className="">
              <NavLink to="/"></NavLink>
            </li>
            <li className="">
              <NavLink to="/espCandidat">EspaceCandidat</NavLink>
            </li>
          </ul>
        
      
    </nav>
    </header>

  
      <section>
   <div class="container">
			<div class="row">
				<div className="col-md-12 col-sm-12 text-center">
					<h2> Simulation TCF-CANADA</h2>
					<p className="lead">Entrainnement aux pre-inscription en ligne du test de langue cas de l'IFC </p>
				</div>
			
			</div>

		</div>
      

       </section> 
       <section className="section">
       <div className="container">
       <div className="row" style={{ display: 'flex' }}>
       <div className="content col-md-8 blog-alt" style={{ flex: '1' }}>
       <div className="blog-box clearfix">
       <div className="media-box">
							<img src={imageUrl} alt="Image examen TCF-CANADA IFC."  class="img-responsive img-thumbnail"
                      style={{
                        width: '700px',
                        height: '400px',}}/>
						</div>
                  <div className="blog-single">
                  <div className="blog-single">
							<div className="blog-meta">
								<ul className="list-inline"></ul>
							</div>
                     <h3 className="post-title text-center">Test de Connaissance du Français pour le Canada<br/>
								(TCF-CANADA)</h3>
                        <p>Le TCF Canada est un test accr&eacute;dit&eacute; par Immigration, r&eacute;fugi&eacute;s et citoyennet&eacute; Canada (<a href="https://www.canada.ca/fr/immigration-refugies-citoyennete/services/immigrer-canada/entree-express/documents/exigences-linguistiques/evaluation-competences-linguistiques.html" target="_blank" title="IRCC - site externe - ouverture dans un nouvel onglet">IRCC</a>).<br />
Le TCF Canada est &eacute;galement reconnu, depuis fin janvier 2022, par le minist&egrave;re de Immigration, de la Francisation et de l&#39;Int&eacute;gration (<a href="http://www.mifi.gouv.qc.ca/fr/reglementation-consultants/connaissance-francais.html" target="_blank" title="MIFI - site externe - ouverture dans un nouvel onglet">MIFI</a>) pour une demande d&rsquo;immigration vers le Canada f&eacute;d&eacute;ral..</p>

<p>Il n&rsquo;existe pas de cas de dispense pour le TCF Canada.</p>
<p>Vous pouvez desormais vous entrainer grace a cette applications pour les pre-inscription en ligne.</p>
<h2>Pr&eacute;sentation des &eacute;preuves</h2>

<p>Le TCF Canada est compos&eacute; de 4 &eacute;preuves obligatoires &eacute;valuant les comp&eacute;tences en fran&ccedil;ais langue g&eacute;n&eacute;rale :</p>
<ol>
	<li><strong>Compr&eacute;hension orale</strong>&nbsp;: &Eacute;preuve collective : 39 questions &agrave; choix multiple (4 choix de r&eacute;ponses, une seule r&eacute;ponse correcte)</li>
	<li><strong>Compr&eacute;hension &eacute;crite</strong>&nbsp;: &Eacute;preuve collective : 39 questions &agrave; choix multiple (1 seule bonne r&eacute;ponse possible)</li>
	<li><strong>Expression &eacute;crite</strong>&nbsp;: &Eacute;preuve collective : 3 exercices</li>
	<li><strong>Expression orale</strong>&nbsp;: Epreuve individuelle en face &agrave; face avec un examinateur : 3 exercices</li>
</ol>
<p>Le TCF Canada &agrave; une dur&eacute;e totale de 2 heures 47mins :</p>

<ul>
	<li>Compr&eacute;hension orale : 35 minutes ;</li>
	<li>Compr&eacute;hension &eacute;crite : 60 minutes ;</li>
	<li>Expression &eacute;crite : 60 minutes ;</li>
	<li>Expression orale : 12 minutes (dont 2 minutes de pr&eacute;paration).</li>
</ul>
<p>
      <span style={{ color: '#c0392b' }}>
        <u>Attention:</u>&nbsp;
      </span>
      Examen sur ordinateur. Le candidat passe les 3 &eacute;preuves collectives sur un ordinateur mis &agrave; sa disposition par le centre d&#39;examen.
    </p>
    <p>
      <span style={{ color: '#c0392b' }}>
        <u>NB:</u>&nbsp;
      </span>
     Ici n'est pas un test de pr&eacute;paration au test de langue mais une pr&eacute;paration au pr&eacute;-inscription   &agrave; l'IFC ;.
    </p>
    
                     </div>
                     </div> 

         </div>
         <div className="sidebar col-md-4 col-sm-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
         <div className="pricing-box clearfix">
         <div className="pricing-header firstch" >
							
						</div>
                  <div class="pricing-top secondch" style={{padding: '20px 0'}}>
                  <article className="article"
     style={{ textAlign: 'right' }}
      data-price="210000"
      id="examenPriceShow"
    >
   <h4>Prix de l'examen</h4>
      210 000 FCFA
    </article>  
    
                        <h2>Je me renseigne</h2>
                     <span>Pour répondre à toutes vos questions, veuillez lire les questions fréquemment
                     posées. Cliquer sur l'icone "?" ou aliquer sur le lien faq</span>  
                          
                    
                    <section
      className="section normalhead"
      style={{
       display : 'flex'
       
      
      }}
    >  <p style={{fontWeight: 'bold'}}>Cliquez sur le bouton ci dessous pour debuter la simulation</p>
     <div class="col-md-12 col-sm-12 text-center">
     <a className="btn" href="/faq/"><button className="rounded-button">Commencer</button></a>
      </div>
    
    
    </section>
						</div> 
            </div>

          

         </div>
         </div>
       </div>
         </div>  
       </section>
       <div>
    <a href="/" > <Icon name="precedent" /></a>
    <a href="/Examen" ><Icon name="question" /></a>
    <a href="/faq" > <Icon name="register" /></a>
    <a href="/accueil" > <Icon name="home" /></a>
    </div>
       <footer className="footer secondary-footer"  style={{ backgroundColor: '#928490 ' }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12" style={{ textAlign: 'center' }}>
            <p> Objectif Canada</p>
          </div>
        </div>
       
      </div>
    </footer>
    
    
    
       
       </>
    )
    }
   